import { Injectable, Injector } from '@angular/core';
import { DatabaseManagerProvider } from '../storage-manager/database-manager';
import { Chat } from '../../bayadic-shared-models/chat/Chat';
import { AbstractChatMessage } from '../../bayadic-shared-models/classes/message/abstract-chat-message';
import { ChatMessage } from '../../bayadic-shared-models/classes/message/chat-message';
import { WordObject } from '../../bayadic-shared-models/interfaces/word-object/WordObject';
import { LoggerService } from '../../app/services/logger.service';

interface DictDBWord {
  word: string;
  translations: WordObject[];
}

@Injectable()
export class WordsDatabaseService extends DatabaseManagerProvider {
  wordsDatabaseName: string;
  tableName: string = "de_fa"
  constructor(public injector: Injector,
    public logger: LoggerService
  ) {
    super(injector, logger)
  }
  addWordAndTranslation(word: string,  translations: Array<WordObject>) {
    //return true;
    return new Promise((resolve, reject) => {
      const transaction = this.database.transaction(this.tableName, 'readwrite');
      const objectStore = transaction.objectStore(this.tableName);
      const addRequest = objectStore.add({word:word, translations: translations}); // Open cursor at the end
      addRequest.onsuccess = event => {
        resolve(true)
      };
      addRequest.onerror = () => {
        this.logger.warn('Error adding message:', addRequest.error);
        resolve(false);
      };
    });
  }
  getSuggestions(needle:string){
    return []
  }
  readPagesOfMessage(chat: Chat, pageSize: number = 10, pageNumber: number = 1): Promise<ChatMessage[]> {
    return new Promise(async (resolve, reject) => {
      const storeName = chat.chatID;
      const transaction = this.database.transaction(storeName, "readonly");
      const objectStore = transaction.objectStore(storeName);
      const timestampIndex = objectStore.index('timeIndex');
      let idbKeyRange = null;
      if(chat.messages.length>0){
        idbKeyRange = IDBKeyRange.upperBound(chat.messages[0]?.timestamp);
      }

      // const idbKeyRange = await this.getKeyRange(objectStore, chat)
      // this.logger.debug("idbkeyrange", idbKeyRange)
      const messages: ChatMessage[] = [];
      // const cursorRequest = timestampIndex.openCursor(IDBKeyRange.upperBound(queryTimestamp, true), 'prev');
      const cursorRequest = timestampIndex.openCursor(idbKeyRange, "prev");
      let count = 0;
      cursorRequest.onsuccess = (event: any): void => {
        const cursor = event.target.result;
        if (cursor) {
          if (count >= (pageNumber - 1) * pageSize && count < pageNumber * pageSize) {
            if(cursor.value){
              messages.unshift(cursor.value);
            }
          }
          if (count === pageNumber * pageSize) {
            this.logger.debug("resolved messages",messages)
            resolve(messages); // Resolve the messages array at the end of the page
            return;
          }
          cursor.continue();
          count++;
        } else {
          resolve(messages); // Resolve even if there are fewer messages than requested
        }
      };
      cursorRequest.onerror = (event: any): void => {
        reject(event.error);
      };
    });
  }

  async getCurrentDatabaseVersion(dbName: string): Promise<number> {
    const databastes = await indexedDB.databases()
    const db = databastes.filter(it => it.name === dbName)
    if (db.length > 0) return db[0].version; else return 0;
  }
  async closeDatabase() {
    if (this.database) {
      this.database.close()
    }
  }
  async createTablesIfNotExists() {
    return new Promise(async (resolve, reject) => {

      this.wordsDatabaseName = "words_de_fa";
      this.databaseVersion = await this.getCurrentDatabaseVersion(this.wordsDatabaseName)
      this.closeDatabase()
      const request = indexedDB.open(this.wordsDatabaseName);
      request.onsuccess = (event: Event) => {
        const dbRequest = (event.target as IDBOpenDBRequest).result;
        if (dbRequest) {
          this.database = dbRequest;
          resolve(true)
        }
      }
      request.onerror = (event: Event) => {
        this.logger.error("erro of opening database", event)
        resolve(false)
      }
      request.onupgradeneeded = (event: Event) => {
        const dbRequest = (event.target as IDBRequest).result as IDBDatabase;
        if (!dbRequest.objectStoreNames.contains(this.tableName)) {
          dbRequest.createObjectStore(this.tableName, { keyPath: "word" });
        }
      };
    })

  }
  getTranslation(word:string): Promise<DictDBWord | false> {
    return new Promise(async (resolve, reject) => {
      const transaction = this.database.transaction(this.tableName, "readonly");
      const objectStore = transaction.objectStore(this.tableName);
      const request = objectStore.get(word);

      request.onsuccess = (event) => {
        const foundTranslations = (event.target as IDBRequest).result;
        if (foundTranslations) {
          resolve(foundTranslations)
        } else {
          resolve(false)
        }
      };

      request.onerror = (event) => {
        console.error("Error reading message:", (event.target as IDBRequest).error);
        resolve(false)
      };
    })
  }
  async init() {
    const user = this.userManager.user;
    await this.createTablesIfNotExists()
  }


}
